module.exports = "https://s.pinimg.com/webapp/style/images/TL@2x-acd81f47.png";